import { useEffect, useState } from 'react'
import { api, session } from '../api.js'

const JOURS = [[1, 'lundi'], [2, 'mardi'], [3, 'mercredi'], [4, 'jeudi'], [5, 'vendredi'], [6, 'samedi']]

export default function Creneaux() {
  const [liste, setListe] = useState([])
  const [message, setMessage] = useState('')

  const charger = () => api.agendas().then(setListe)
  useEffect(() => { charger() }, [])   // eslint-disable-line
  const lectureSeule = session.env === 'live'

  async function sauver(key, champs) {
    setListe(liste.map((a) => (a.key === key ? { ...a, ...champs } : a)))
    await api.saveAgenda(key, champs)
    setMessage('Enregistré. Les habitants le verront après la mise en ligne.')
  }

  return (
    <>
      <h1>Créneaux de rendez-vous</h1>
      <p className="chapo">Les horaires que le portail propose aux habitants pour les démarches
        qui se terminent au guichet.</p>
      {message && <p className="succes" role="status">{message}</p>}
      {!lectureSeule && (
        <button className="btn pri" onClick={async () => { await api.createAgenda(); charger() }}>
          Ajouter une permanence
        </button>
      )}

      {liste.map((a) => (
        <section className="carte" key={a.key}>
          <div className="champ">
            <label htmlFor={`n${a.key}`}>Nom affiché aux habitants</label>
            <input id={`n${a.key}`} defaultValue={a.name} disabled={lectureSeule}
                   onBlur={(e) => e.target.value !== a.name && sauver(a.key, { name: e.target.value })} />
          </div>

          <div className="ligne-champs">
            <div className="champ">
              <label htmlFor={`d${a.key}`}>Durée d'un rendez-vous</label>
              <select id={`d${a.key}`} value={a.duration} disabled={lectureSeule}
                      onChange={(e) => sauver(a.key, { duration: Number(e.target.value) })}>
                {[15, 20, 30, 45, 60].map((d) => <option key={d} value={d}>{d} minutes</option>)}
              </select>
            </div>
            <div className="champ">
              <label htmlFor={`c${a.key}`}>Rendez-vous en parallèle</label>
              <input id={`c${a.key}`} type="number" min="1" max="20" defaultValue={a.capacity}
                     disabled={lectureSeule}
                     onBlur={(e) => sauver(a.key, { capacity: Number(e.target.value) })} />
              <p className="aide">Combien de personnes peuvent être reçues sur le même créneau.</p>
            </div>
          </div>

          <fieldset className="champ">
            <legend>Jours d'ouverture</legend>
            <div className="ligne">
              {JOURS.map(([n, nom]) => (
                <label className="case" key={n}>
                  <input type="checkbox" checked={a.days.includes(n)} disabled={lectureSeule}
                         onChange={(e) => sauver(a.key, {
                           days: e.target.checked ? [...a.days, n].sort()
                             : a.days.filter((x) => x !== n),
                         })} />
                  {nom}
                </label>
              ))}
            </div>
          </fieldset>

          <fieldset className="champ">
            <legend>Plages horaires</legend>
            {a.ranges.map((r, i) => (
              <div className="ligne" key={i}>
                <input type="time" value={r[0]} disabled={lectureSeule}
                       onChange={(e) => sauver(a.key, {
                         ranges: a.ranges.map((x, j) => (j === i ? [e.target.value, x[1]] : x)),
                       })} />
                <span>vers</span>
                <input type="time" value={r[1]} disabled={lectureSeule}
                       onChange={(e) => sauver(a.key, {
                         ranges: a.ranges.map((x, j) => (j === i ? [x[0], e.target.value] : x)),
                       })} />
                {!lectureSeule && a.ranges.length > 1 && (
                  <button className="btn sm" onClick={() => sauver(a.key, {
                    ranges: a.ranges.filter((_, j) => j !== i) })}>Retirer</button>
                )}
              </div>
            ))}
            {!lectureSeule && (
              <button className="btn sm" onClick={() => sauver(a.key, {
                ranges: [...a.ranges, ['14:00', '17:00']] })}>Ajouter une plage</button>
            )}
          </fieldset>

          <p className="aide">
            {a.used_by.length ? `Utilisée par : ${a.used_by.join(', ')}` : 'Aucune démarche rattachée'}
            {a.bookings > 0 && ` · ${a.bookings} rendez-vous à venir`}
          </p>
        </section>
      ))}
      {!liste.length && <div className="carte vide"><p>Aucune permanence configurée.</p></div>}
    </>
  )
}
